(function () {
  const stickyBanner = document.querySelector('.sticky_add');
  if (stickyBanner) {
    const stickyBuy = stickyBanner.querySelector('#ProductSubmitButton');
    stickyBuy.setAttribute("disabled", '');
    const stickyBannerVariantSelectors = stickyBanner.querySelector('.product__info-container');
    const sizeFieldset = document.querySelector('#size-variant');
    const sizeChartOpener = stickyBanner.querySelector('.size-chart__opener');
    const config = { childList: true, subtree: true };

    if (!sizeFieldset) return;

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          sizeChartOpener.addEventListener('click', (event) => {
            let sizeChartElement = mutation.addedNodes[0].querySelector('.ks-chart-modal-link');
            const clickEvent = new Event('click');
            if (sizeChartElement) sizeChartElement.dispatchEvent(clickEvent);
          });
          observer.disconnect();
        }
      }
    };

    stickyBuy.addEventListener('click', (e) => {
      e.preventDefault()
      document.querySelector('.product #ProductSubmitButton').click();
    });

    window.addEventListener('click', (event) => {
      if (!stickyBanner.contains(event.target) && !sizeFieldset.contains(event.target) && stickyBannerVariantSelectors.classList.contains('show')) {
        stickyBannerVariantSelectors.classList.remove('show');
      } else if (event.target.querySelector('[name="add"][disabled]')) {
        stickyBannerVariantSelectors.classList.add('show');
      }
    });

    const observer = new MutationObserver(callback);
    observer.observe(sizeFieldset, config);
  }
})();
